<div id="menu-editor" class="p-5 container">
  <div id="header" class="d-flex flex-col justify-content-between align-items-center">
    <h1>Menu Editor</h1>
    <div>
      <button type="button" class="btn btn-primary mr-1" (click)="createNewTrigger()">
        <fa-icon [icon]="faPlus"></fa-icon> Add Trigger
      </button>
      <button type="button" class="btn btn-primary" [routerLink]="['/admin/page', 0]">
        <fa-icon [icon]="faPlus"></fa-icon> Add New Page
      </button>
    </div>
  </div>
  <div cdkDropListGroup>
    <div cdkDropListGroup cdkDropList (cdkDropListDropped)="drop($event, 0, true)">
      @for (opt of editablePages; track opt; let i = $index) {
        <div cdkDrag class="example-container">
          <div class="custom-placeholder" *cdkDragPlaceholder></div>
          <div class="example-box">
            <div class="action">
              @if (opt.name !== 'Unassigned') {
                <div class="icon" (click)="updateTrigger(opt.name, i)">
                  <fa-icon [icon]="faPencilAlt" size="xs"></fa-icon>
                </div>
              }
              <div class="eye">
                <fa-icon (click)="togglePublished(i)" [icon]="opt.isPublished ? faEye : faEyeSlash" [ngClass]="{'gray': !opt.isPublished}"></fa-icon>
              </div>
            </div>
            <div class="d-flex flex-grow-1 drag" cdkDragHandle>
              <h2>{{ opt.name }}</h2>
            </div>
            <div class="action">
              <div>
                <p class="trigger">TRIGGER</p>
              </div>
              <!-- <div class="icon warn"><fa-icon [icon]="faTrash" size="xs" (click)="delete(i)"></fa-icon></div> -->
            </div>
          </div>
          <div cdkDropList class="example-list sub-item" (cdkDropListDropped)="drop($event, i)" [id]="i.toString()">
            @for (item of opt.subMenuItems; track item; let si = $index) {
              <div class="example-box" cdkDrag>
                <div class="custom-placeholder" *cdkDragPlaceholder></div>
                <div class="action">
              <div class="icon" (click)="
                  item.hrefLink
                    ? updateExternal(item, si)
                    : editPage(item.id, $safeNavigationMigration(item?.isEditable))
                ">
                    <fa-icon [icon]="faPencilAlt" size="xs"></fa-icon>
                  </div>
                  <div class="eye">
                    <fa-icon (click)="togglePublished(i, si)" [icon]="item.isPublished ? faEye : faEyeSlash" [ngClass]="{'gray': !item.isPublished}"></fa-icon>
                  </div>
                  <div><fa-icon [icon]="faBars"></fa-icon></div>
                </div>
                <div class="d-flex flex-grow-1 drag">
                  <p class="page-name">{{ item.name }}</p>
                </div>
                <div class="action">
                  @if (item.hrefLink) {
                    <div>
                      <span class="badge bg-darkred">[EXTERNAL]</span>
                    </div>
                  }
                  <div class="icon warn">
                    <fa-icon [icon]="faTrash" size="xs" (click)="delete(item)" ></fa-icon>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div class="sticky-bar">
  <div class="note">
    <p>
      <b>Note:</b> Changes to menu are saved when submitted with "Save Changes"
      button.
    </p>
  </div>
  <div>
    <button (click)="confirmDiscard()" type="button" class="btn btn-outline-secondary btn-sm">
      Cancel@if (orderChanged) {
      <span> and Discard</span>
    }
  </button>
  <button (click)="onSubmit()" type="button" class="btn btn-primary btn-sm">
    Save Changes
  </button>
</div>
</div>